import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { SettingsProvider } from './context/SettingsContext';
import Workspace from './components/Workspace';
import Overview from './pages/Overview';
import Catalog from './pages/Catalog';
import ProductEditor from './pages/ProductEditor';
import Billing from './pages/Billing';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import Inventory from './pages/Inventory';
import Contacts from './pages/Contacts';
import Analytics from './pages/Analytics';
import DataBackup from './pages/DataBackup';
import Preferences from './pages/Preferences';
import './App.css';

export default function App() {
  return <SettingsProvider><BrowserRouter><Workspace><Routes>
    <Route path="/" element={<Overview/>}/>
    <Route path="/products" element={<Catalog/>}/>
    <Route path="/products/:id" element={<ProductEditor/>}/>
    <Route path="/new-bill" element={<Billing/>}/>
    <Route path="/sales" element={<Invoices/>}/>
    <Route path="/sales/:id" element={<InvoiceDetail/>}/>
    <Route path="/stock" element={<Inventory/>}/>
    <Route path="/customers" element={<Contacts key="customers" type="customers"/>}/>
    <Route path="/suppliers" element={<Contacts key="suppliers" type="suppliers"/>}/>
    <Route path="/reports" element={<Analytics/>}/>
    <Route path="/backup" element={<DataBackup/>}/>
    <Route path="/settings" element={<Preferences/>}/>
    <Route path="*" element={<div className="shop-page"><h1>Page not found</h1><Link data-testid="not-found-home" to="/">Back to shop</Link></div>}/>
  </Routes></Workspace><Toaster richColors position="top-right"/></BrowserRouter></SettingsProvider>;
}
